import request from "../../../../../../../service";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { IErrorResponse, IRootState } from "../../../../../../../types";
import { deleteBuildings, deletedRestoreBuildings, setBuildings, setBuildingsRestore } from "../store/buildingsSlice";
import { IBuildingsCreate, IBuildingsPayload } from "../types";

const GetBuildings = createAsyncThunk("get/buildings", async (_, { dispatch, rejectWithValue, getState }) => {
    try {
        const response = await request.get("/buildings");
        const lang = getState() as IRootState;
        const defaultLanguage = lang.languages.defaultLanguage;

        dispatch(setBuildings({ data: response.data, defaultLanguage }));
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const CreateBuildings = createAsyncThunk("create/buildings", async (data: IBuildingsCreate, { rejectWithValue }) => {
    try {
        const response = await request.post("/buildings", data);
        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const DeleteBuildings = createAsyncThunk("delete/buildings", async (id: number, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.delete(`/buildings/${id}`);

        dispatch(deleteBuildings(id));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});
const EditBuildings = createAsyncThunk("edit/buildings", async (data: IBuildingsPayload, { rejectWithValue }) => {
    try {
        const response = await request.put(`/buildings/${data.id}`, data);

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const GetDeleteBuildings = createAsyncThunk("get/delete/buildings", async (_, { dispatch, rejectWithValue }) => {
    try {
        const response = await request.get(`/buildings/deleted-items`);

        dispatch(setBuildingsRestore(response.data));

        return response.data;
    } catch (error) {
        const typedError = error as IErrorResponse;
        return rejectWithValue(typedError.response.data.message || "unexpected_fail");
    }
});

const RestoreDeleteBuildings = createAsyncThunk(
    "restore/delete/buildings",
    async (id: number, { dispatch, rejectWithValue }) => {
        try {
            const response = await request.post(`/buildings/restore/${id}`);

            dispatch(deletedRestoreBuildings(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

export { GetBuildings, DeleteBuildings, CreateBuildings, EditBuildings, GetDeleteBuildings, RestoreDeleteBuildings };
